export const pageOrder = {
  ACCEPT: 99,
  CONTACT: 88,
  ABOUT_YOU_DISCLOSURE: 77,
  GETTING_STARTED: 0,
  COVER: 1,
  QUOTE: 2,
  SAVE_AND_EMAIL: 33, //* New
  ABOUT_YOU_INFORMATION: 3, //* New
  ABOUT_YOU_DECLARATIONS: 4, //* New
  ABOUT_YOU_QUESTIONS: 5,
  REVIEW_APPLICATION: 6,
  PP_ONLINE_POLICY_OUTCOME: 7,
  PP_CONTACT: 8, //* PP is Purchase Path
  PP_ONLINE_PAYMENT: 9,
  PP_CONFIRMATION: 10,
  PP_POLICY_OUTCOME_DECLINE: 11,
  /* Retrieve quote loading needs to be the last page in the index. We need the retrieve loading page to be present
   inside the ContactCenterLayout.jsx so that the initial state is kicked in and once we get retrieve information from API, then we add to the state
   Adding all the pages of outcome outside the sequence */
  RETRIEVE_QUOTE_LOADING: 12,
  RETRIEVE_DECLINE: 13,
  RETRIEVE_EXPIRED: 14,
  RETRIEVE_REFERRED_UW: 15,
  RETRIEVE_BOUND: 16,
  APPLICATION_ALREADY_DECLINED: 17,
};

export const pageOrderCC = {
  SCRIPT: 99,
  CONTACT: 88,
  ABOUT_YOU_DISCLOSURE: 77,
  GETTING_STARTED: 0,
  COVER: 1,
  QUOTE: 2,
  SAVE_AND_EMAIL: 33, //* New
  ABOUT_YOU_INFORMATION: 3, //* New
  ABOUT_YOU_DECLARATIONS: 4, //* New
  ABOUT_YOU_QUESTIONS: 5,
  REVIEW_APPLICATION: 6,
  PP_CC_POLICY_OUTCOME: 7,
  PP_CONTACT: 8,
  PP_CC_PAYMENT: 9,
  PP_CONFIRMATION: 10,
  PP_POLICY_OUTCOME_DECLINE: 11,
  /* Retrieve quote loading needs to be the last page in the index. We need the retrieve loading page to be present
   inside the ContactCenterLayout.jsx so that the initial state is kicked in and once we get retrieve information from API, then we add to the state
   Adding all the pages of outcome outside the sequence */
  RETRIEVE_QUOTE_LOADING: 12,
  RETRIEVE_DECLINE: 13,
  RETRIEVE_EXPIRED: 14,
  RETRIEVE_REFERRED_UW: 15,
  RETRIEVE_BOUND: 16,
  APPLICATION_ALREADY_DECLINED: 17,
  PP_CC_UPGRADE_SAVE_CONFIRMATION: 18,
};
